module.exports = __webpack_public_path__ + "img/item3.45f8ae90.png";